export default __webpack_public_path__ + "static/media/Sport.04dd3b00.svg";